<template>
  <div>
    <footer class="footer" :class="this.footer=='footer-dark'?'footer-dark':''">
      <div class="container-fluid">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="row">
              <div class="col-md-2 footer-copyright text-center">
                <p class="mb-0">Faqs</p>
              </div>
              <div class="col-md-2 footer-copyright text-center">
                <p class="mb-0">Feedback & Suggestion</p>
              </div>
              <div class="col-md-2 footer-copyright text-center">
                <p class="mb-0">Privacy Policy</p>
              </div>
              <div class="col-md-2 footer-copyright text-center">
                <p class="mb-0">Terms & Conditions</p>
              </div>
              <div class="col-md-2 footer-copyright text-center">
                <p class="mb-0">Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu';
  import { mapGetters } from 'vuex'
  export default {
    name: 'footerpage',
    data() {
      return {
        customizer: false,
        data:
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
    computed:{
          ...mapGetters({
            footer: 'layout/footer'
          })
        }
  };
</script>
